import { createSlice } from "@reduxjs/toolkit";
import { getAxios, postAxios } from "./axiosActions";
import _ from 'lodash';
import { getDataUrl, getMimeType, getFileName, getFolderFullName } from "../../common/utils";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
const download = require("downloadjs");

export const initialState = {
    loading: false,
    hasErrors: false,
    files: [],
    progress:0,
};
function buildFolderStructure(folderPaths) {
    const root = {};
  
    for (const path of folderPaths) {
      const parts = path.split('/');
      let current = root;
  
      for (const part of parts) {
        if (!current[part]) {
          current[part] = {};
        }
        current = current[part];
      }
    }
  
    return root;
  }
  
  function addToZip(zip, currentPath, structure,files) {
    for (const name in structure) {
      const value = structure[name];
      const fullPath = currentPath ? `${currentPath}/${name}` : name;

      if (value != null) {
        const folder = zip.folder(name);
        addToZip(folder, '', value,files);
      } else {
        let file=_.find(files,{name:name})
        zip.file(getFileName(file.name), file.content, {base64: true});
      }
    }
  }

  function insertFilesIntoStructure(structure, filePaths) {
    for (const filePath of filePaths) {
      const parts = filePath.path.split('/');
      insertFile(structure, parts);
    }
  }

function insertFile(node, parts) {
    const [current, ...rest] = parts;
  
    if (rest.length === 0) {
      // It's file
      node[current] = null;
      return;
    }
  
    // It's folder
    if (!node[current]) {
      node[current] = {};
    }
  
    insertFile(node[current], rest);
  }
  
const uploadSlice = createSlice({
    name: 'upload',
    initialState,
    reducers: {
        apiHit: state => {
            state.loading = true;
        },
        updateFilesSuccess: (state, { payload }) => { 
            state.files = payload;
            state.loading = false;
            state.hasErrors = false;
        },
        apiCallFailure: state => {
            state.loading = false;
            state.hasErrors = true;
        },
        getFilesSuccess: (state, { payload }) => { 
            state.files = payload;
            state.loading = false;
            state.hasErrors = false;
        },
        getFileSuccess: (state, { payload }) => {               
            if (payload) 
            {
                state.selectedFile =  payload[0]?.content;
            } 
            state.loading = false;
            state.hasErrors = false;
        },
        getDownloadSuccess: (state, { payload }) => { 
            state.selectedFile =  payload.response;            
            if (payload.response) 
            {
                _.map(payload.response.files,(item,index)=>{
                    const dataUrl = getDataUrl(getFileName(item.name),item.content)
                    download(dataUrl, getFileName(item.name), getMimeType(item.name));
                })
                _.map(payload.response.folders,(item,index)=>{
                    let folderList=[];
                    
                    _.map(item.files,file=>{
                        let folderName=getFolderFullName(item.name+"/"+file.path.split(item.name)[1],file.name);
                        folderList.push(folderName)
                    })
                    const structure = buildFolderStructure(_.compact(folderList));
                    let filesList=[]
                    _.map(item.files,file=>{
                            filesList.push({path:item.name+_.split(file.path,item.name)[1],name:file.name,content:file.content})
                    })
                    insertFilesIntoStructure(structure,filesList)
                    const zip = new JSZip();
                    addToZip(zip, '', structure,item.files);

                    zip.generateAsync({ type: 'blob' }).then(function(content) {
                        saveAs(content, item.name);
                    });
                })
            } 
            state.loading = false;
            state.hasErrors = false;
        },
        clearSelected: state => {
            state.selectedFile =  "";
        },
        getAllUsersSuccess: (state, { payload }) => {   
            if (payload) 
            {
                state.users =  payload;
            } 
            state.loading = false;
            state.hasErrors = false;
        },
        getAccessUsersSuccess: (state, { payload }) => {   
            if (payload) 
            {
                state.accessUsers =  payload;
            } 
            state.loading = false;
            state.hasErrors = false;
        },
        setProgressSuccess: (state,{payload} )=> {
            state.isFileLoader =  payload;
        },
    },
});

export const { apiHit, updateFilesSuccess,getFilesSuccess,getFileSuccess,getDownloadSuccess, apiCallFailure,clearSelected,getAllUsersSuccess,getAccessUsersSuccess,setProgressSuccess} = uploadSlice.actions;

export const uploadSelector = state => state.upload;
export default uploadSlice.reducer;

export const updateFiles = (data) => {
    return async dispatch => {
        dispatch(apiHit());
        dispatch(setProgressSuccess(true))
        try {
            const response = await postAxios('Api/Upload/UploadFiles', { params: data });
            dispatch(updateFilesSuccess(response));
            dispatch(setProgressSuccess(false))
            
        } catch (error) {
            dispatch(apiCallFailure());
            dispatch(setProgressSuccess(false))
        }        
    }
};
export const getFiles = (userId) => {
    return async dispatch => {
        dispatch(apiHit());
        dispatch(setProgressSuccess(true))
        try {
            const response = await getAxios('Api/Upload/GetFiles?userId=' + userId, { params: {} });
            dispatch(getFilesSuccess(response));
            dispatch(setProgressSuccess(false))
        } catch (error) {
            dispatch(apiCallFailure());
            dispatch(setProgressSuccess(false))
        }
    }
};
export const getFile = (path) => {
    return async dispatch => {
        dispatch(apiHit());
        dispatch(clearSelected());
        dispatch(setProgressSuccess(true))
        try {
            const response = await postAxios('Api/Upload/GetFile' , { params: path });
            dispatch(getFileSuccess(response));
            dispatch(setProgressSuccess(false))
        } catch (error) {
            dispatch(apiCallFailure());
            dispatch(setProgressSuccess(false))
        }
    }
};
export const downloadFile = (path) => {
    return async dispatch => {
        dispatch(apiHit());
        dispatch(clearSelected());
        dispatch(setProgressSuccess(true))
        try {
            const response = await postAxios('Api/Upload/DownloadFile', { params: path });
            dispatch(getDownloadSuccess({response, fileName:path}));
            dispatch(setProgressSuccess(false))
        } catch (error) {
            dispatch(apiCallFailure());
            dispatch(setProgressSuccess(false))
        }
    }
};
export const deleteFile = (path) => {   
    return async dispatch => {
        dispatch(apiHit());
        dispatch(setProgressSuccess(true))
        try {
            const response = await postAxios('Api/Upload/DeleteFile', { params: {path} });
            dispatch(getFilesSuccess(response));
            dispatch(setProgressSuccess(false))
        } catch (error) {
            dispatch(apiCallFailure());
            dispatch(setProgressSuccess(false))
        }
    }
};
export const getAllUsers = (path) => {
    return async dispatch => {
        dispatch(apiHit());
        dispatch(setProgressSuccess(true))
        try {
            const response = await getAxios('Api/CustomAuth/GetAllUsers', { params: {} });
            dispatch(getAllUsersSuccess(response));
            dispatch(setProgressSuccess(false))
        } catch (error) {
            dispatch(apiCallFailure());
            dispatch(setProgressSuccess(false))
        }
    }
};
export const getAccessUsers = (userId) => {
    return async dispatch => {
        dispatch(apiHit());
        dispatch(setProgressSuccess(true))
        try {
            const response = await getAxios('Api/CustomAuth/GetAccessUsers?userId='+userId, { params: {} });
            dispatch(getAccessUsersSuccess(response));
            dispatch(setProgressSuccess(false))
        } catch (error) {
            dispatch(apiCallFailure());
            dispatch(setProgressSuccess(false))
        }
    }
};
export const updateFolder = (data) => {
    return async dispatch => {
        dispatch(apiHit());
        dispatch(setProgressSuccess(true))
        try {
            const response = await postAxios('Api/Upload/UploadFolder', { params: data });
            dispatch(updateFilesSuccess(response));
            dispatch(setProgressSuccess(false))
        } catch (error) {
            dispatch(apiCallFailure());
            dispatch(setProgressSuccess(false))
        }
    }
};

